module.exports = __webpack_public_path__ + "img/typingspeed.4def5734.svg";